import { Outlet } from 'react-router-dom';
import { Box } from '@mui/material';

export function AttendanceLayout() {
  return (
    <Box sx={{ width: '100%', display: 'flex', flexDirection: 'column', gap: 3 }}>
      <Outlet />
    </Box>
  );
}
